<script>
// 加载中
import InnerLoading from '@/components/spinner/spinner.vue';
export default {
  name:'home',
  data(){
    return{
      innerLoading:false,
      url_openid:'',
      activeTab:'2',
      page1:1,//当前页
      size1:20,//每页条数
      totals1:0,//总条数
      totalPages1:0,//总页数
      finished1: true,
      loading1:false,
      finishedMsgTxt:'没有更多了',
      listData:[
        {
          "scoreId": "1922334302679363585",
          "openId": "abc",
          "day":13,
          "rule": {
            "createDept": 103,
            "createBy": 1,
            "createTime": "2025-05-14 00:53:08",
            "updateBy": 1,
            "updateTime": "2025-05-14 00:53:08",
            "ruleId": 4,
            "ruleTitle": "邀请好友奖励规则",
            "rulePhrase": "福彩用户体验调研",
            "ruleDesc": "邀请好友参与活动每人奖励50积分，仅限被邀请人为新用户的首次邀请",
            "ruleCode": 4,
            "ruleClass": "4元电脑票体验券",
            "ruleScore": 10,
            "ruleStatus": 0,
            "operationType": 0,
            "isVisible": 0
          },
          "scanId": null,
          "inviteId": null,
          "winningId": null,
          "scoreChange": 50,
          "currentScore": 70,
          "operationSource": "邀请好友",
          "remark": "bcd",
          "createTime": "2025-05-14 00:53:08",
          "updateTime": "2025-05-14 00:53:08"
        },
        {
          "scoreId": "1922334254809772034",
          "openId": "bcd",
          "day":15,
          "rule": {
            "createDept": 103,
            "createBy": 1,
            "createTime": "2025-05-14 00:52:56",
            "updateBy": 1,
            "updateTime": "2025-05-14 00:52:56",
            "ruleId": 2,
            "ruleTitle": "首次参与奖励规则",
            "rulePhrase": "福彩用户体验调研",
            "ruleDesc": "用户首次参与活动额外奖励20积分，仅限一次",
            "ruleCode": 2,
            "ruleClass": "4元电脑票体验券",
            "ruleScore": -20,
            "ruleStatus": 0,
            "operationType": 0,
            "isVisible": 0
          },
          "scanId": null,
          "inviteId": null,
          "winningId": null,
          "scoreChange": 20,
          "currentScore": 20,
          "operationSource": "4元电脑票体验券",
          "remark": "邀请注册，首次参与赠送积分",
          "createTime": "2025-05-14 00:52:56",
          "updateTime": "2025-05-14 00:52:56"
        },
        {
          "scoreId": "1922333418717212674",
          "openId": "abc",
          "day":"已过期",
          "rule": {
            "createDept": 103,
            "createBy": 1,
            "createTime": "2025-05-14 00:49:37",
            "updateBy": 1,
            "updateTime": "2025-05-14 00:49:37",
            "ruleId": 2,
            "ruleTitle": "首次参与奖励规则",
            "rulePhrase": "福彩用户体验调研",
            "ruleDesc": "用户首次参与活动额外奖励20积分，仅限一次",
            "ruleCode": 2,
            "ruleClass": "4元电脑票体验券",
            "ruleScore": 20,
            "ruleStatus": 0,
            "operationType": 0,
            "isVisible": 0
          },
          "scanId": null,
          "inviteId": null,
          "winningId": null,
          "scoreChange": 20,
          "currentScore": 20,
          "operationSource": "4元电脑票体验券",
          "remark": "自行注册，首次参与赠送积分",
          "createTime": "2025-05-14 00:49:37",
          "updateTime": "2025-05-14 00:49:37"
        },
        {
          "scoreId": "1922334302679363585",
          "openId": "abc",
          "rule": {
            "createDept": 103,
            "createBy": 1,
            "createTime": "2025-05-14 00:53:08",
            "updateBy": 1,
            "updateTime": "2025-05-14 00:53:08",
            "ruleId": 4,
            "ruleTitle": "福彩用户体验调研",
            "rulePhrase": "红楼探秘2",
            "ruleDesc": "红楼探秘2活动每人奖励50积分，仅限被邀请人为新用户的首次邀请",
            "ruleCode": 4,
            "ruleClass": "4元电脑票体验券",
            "ruleScore": 50,
            "ruleStatus": 0,
            "operationType": 0,
            "isVisible": 0
          },
          "scanId": null,
          "inviteId": null,
          "winningId": null,
          "scoreChange": 50,
          "currentScore": 70,
          "operationSource": "福彩用户体验调研",
          "remark": "bcd",
          "createTime": "2025-05-14 00:53:08",
          "updateTime": "2025-05-14 00:53:08"
        },
        {
          "scoreId": "1922334254809772034",
          "openId": "bcd",
          "rule": {
            "createDept": 103,
            "createBy": 1,
            "createTime": "2025-05-14 00:52:56",
            "updateBy": 1,
            "updateTime": "2025-05-14 00:52:56",
            "ruleId": 2,
            "ruleTitle": "福彩用户体验调研",
            "rulePhrase": "花开中国梦",
            "ruleDesc": "用户首次参与活动额外奖励20积分，仅限一次",
            "ruleCode": 2,
            "ruleClass": "4元电脑票体验券",
            "ruleScore": 20,
            "ruleStatus": 0,
            "operationType": 0,
            "isVisible": 0
          },
          "scanId": null,
          "inviteId": null,
          "winningId": null,
          "scoreChange": 20,
          "currentScore": 20,
          "operationSource": "福彩用户体验调研",
          "remark": "邀请注册，首次参与赠送积分",
          "createTime": "2025-05-14 00:52:56",
          "updateTime": "2025-05-14 00:52:56"
        },
        {
          "scoreId": "1922333418717212674",
          "openId": "abc",
          "rule": {
            "createDept": 103,
            "createBy": 1,
            "createTime": "2025-05-14 00:49:37",
            "updateBy": 1,
            "updateTime": "2025-05-14 00:49:37",
            "ruleId": 2,
            "ruleTitle": "福彩用户体验调研",
            "rulePhrase": "花开中国梦",
            "ruleDesc": "用户首次参与活动额外奖励20积分，仅限一次",
            "ruleCode": 2,
            "ruleClass": "4元电脑票体验券",
            "ruleScore": 20,
            "ruleStatus": 0,
            "operationType": 0,
            "isVisible": 0
          },
          "scanId": null,
          "inviteId": null,
          "winningId": null,
          "scoreChange": 20,
          "currentScore": 20,
          "operationSource": "福彩用户体验调研",
          "remark": "自行注册，首次参与赠送积分",
          "createTime": "2025-05-14 00:49:37",
          "updateTime": "2025-05-14 00:49:37"
        },{
          "scoreId": "1922334302679363585",
          "openId": "abc",
          "rule": {
            "createDept": 103,
            "createBy": 1,
            "createTime": "2025-05-14 00:53:08",
            "updateBy": 1,
            "updateTime": "2025-05-14 00:53:08",
            "ruleId": 4,
            "ruleTitle": "福彩用户体验调研",
            "rulePhrase": "红楼探秘2",
            "ruleDesc": "红楼探秘2活动每人奖励50积分，仅限被邀请人为新用户的首次邀请",
            "ruleCode": 4,
            "ruleClass": "4元电脑票体验券",
            "ruleScore": 50,
            "ruleStatus": 0,
            "operationType": 0,
            "isVisible": 0
          },
          "scanId": null,
          "inviteId": null,
          "winningId": null,
          "scoreChange": 50,
          "currentScore": 70,
          "operationSource": "福彩用户体验调研",
          "remark": "bcd",
          "createTime": "2025-05-14 00:53:08",
          "updateTime": "2025-05-14 00:53:08"
        },
        {
          "scoreId": "1922334254809772034",
          "openId": "bcd",
          "rule": {
            "createDept": 103,
            "createBy": 1,
            "createTime": "2025-05-14 00:52:56",
            "updateBy": 1,
            "updateTime": "2025-05-14 00:52:56",
            "ruleId": 2,
            "ruleTitle": "福彩用户体验调研",
            "rulePhrase": "花开中国梦",
            "ruleDesc": "用户首次参与活动额外奖励20积分，仅限一次",
            "ruleCode": 2,
            "ruleClass": "4元电脑票体验券",
            "ruleScore": 20,
            "ruleStatus": 0,
            "operationType": 0,
            "isVisible": 0
          },
          "scanId": null,
          "inviteId": null,
          "winningId": null,
          "scoreChange": 20,
          "currentScore": 20,
          "operationSource": "福彩用户体验调研",
          "remark": "邀请注册，首次参与赠送积分",
          "createTime": "2025-05-14 00:52:56",
          "updateTime": "2025-05-14 00:52:56"
        },
        {
          "scoreId": "1922333418717212674",
          "openId": "abc",
          "rule": {
            "createDept": 103,
            "createBy": 1,
            "createTime": "2025-05-14 00:49:37",
            "updateBy": 1,
            "updateTime": "2025-05-14 00:49:37",
            "ruleId": 2,
            "ruleTitle": "福彩用户体验调研",
            "rulePhrase": "花开中国梦",
            "ruleDesc": "用户首次参与活动额外奖励20积分，仅限一次",
            "ruleCode": 2,
            "ruleClass": "4元电脑票体验券",
            "ruleScore": 20,
            "ruleStatus": 0,
            "operationType": 0,
            "isVisible": 0
          },
          "scanId": null,
          "inviteId": null,
          "winningId": null,
          "scoreChange": 20,
          "currentScore": 20,
          "operationSource": "福彩用户体验调研",
          "remark": "自行注册，首次参与赠送积分",
          "createTime": "2025-05-14 00:49:37",
          "updateTime": "2025-05-14 00:49:37"
        },{
          "scoreId": "1922334302679363585",
          "openId": "abc",
          "rule": {
            "createDept": 103,
            "createBy": 1,
            "createTime": "2025-05-14 00:53:08",
            "updateBy": 1,
            "updateTime": "2025-05-14 00:53:08",
            "ruleId": 4,
            "ruleTitle": "福彩用户体验调研",
            "rulePhrase": "红楼探秘2",
            "ruleDesc": "红楼探秘2活动每人奖励50积分，仅限被邀请人为新用户的首次邀请",
            "ruleCode": 4,
            "ruleClass": "4元电脑票体验券",
            "ruleScore": 50,
            "ruleStatus": 0,
            "operationType": 0,
            "isVisible": 0
          },
          "scanId": null,
          "inviteId": null,
          "winningId": null,
          "scoreChange": 50,
          "currentScore": 70,
          "operationSource": "福彩用户体验调研",
          "remark": "bcd",
          "createTime": "2025-05-14 00:53:08",
          "updateTime": "2025-05-14 00:53:08"
        },
        {
          "scoreId": "1922334254809772034",
          "openId": "bcd",
          "rule": {
            "createDept": 103,
            "createBy": 1,
            "createTime": "2025-05-14 00:52:56",
            "updateBy": 1,
            "updateTime": "2025-05-14 00:52:56",
            "ruleId": 2,
            "ruleTitle": "福彩用户体验调研",
            "rulePhrase": "花开中国梦",
            "ruleDesc": "用户首次参与活动额外奖励20积分，仅限一次",
            "ruleCode": 2,
            "ruleClass": "4元电脑票体验券",
            "ruleScore": 20,
            "ruleStatus": 0,
            "operationType": 0,
            "isVisible": 0
          },
          "scanId": null,
          "inviteId": null,
          "winningId": null,
          "scoreChange": 20,
          "currentScore": 20,
          "operationSource": "福彩用户体验调研",
          "remark": "邀请注册，首次参与赠送积分",
          "createTime": "2025-05-14 00:52:56",
          "updateTime": "2025-05-14 00:52:56"
        },
        {
          "scoreId": "1922333418717212674",
          "openId": "abc",
          "rule": {
            "createDept": 103,
            "createBy": 1,
            "createTime": "2025-05-14 00:49:37",
            "updateBy": 1,
            "updateTime": "2025-05-14 00:49:37",
            "ruleId": 2,
            "ruleTitle": "福彩用户体验调研",
            "rulePhrase": "花开中国梦",
            "ruleDesc": "用户首次参与活动额外奖励20积分，仅限一次",
            "ruleCode": 2,
            "ruleClass": "4元电脑票体验券",
            "ruleScore": 20,
            "ruleStatus": 0,
            "operationType": 0,
            "isVisible": 0
          },
          "scanId": null,
          "inviteId": null,
          "winningId": null,
          "scoreChange": 20,
          "currentScore": 20,
          "operationSource": "福彩用户体验调研",
          "remark": "自行注册，首次参与赠送积分",
          "createTime": "2025-05-14 00:49:37",
          "updateTime": "2025-05-14 00:49:37"
        },{
          "scoreId": "1922334302679363585",
          "openId": "abc",
          "rule": {
            "createDept": 103,
            "createBy": 1,
            "createTime": "2025-05-14 00:53:08",
            "updateBy": 1,
            "updateTime": "2025-05-14 00:53:08",
            "ruleId": 4,
            "ruleTitle": "福彩用户体验调研",
            "rulePhrase": "红楼探秘2",
            "ruleDesc": "红楼探秘2活动每人奖励50积分，仅限被邀请人为新用户的首次邀请",
            "ruleCode": 4,
            "ruleClass": "4元电脑票体验券",
            "ruleScore": 50,
            "ruleStatus": 0,
            "operationType": 0,
            "isVisible": 0
          },
          "scanId": null,
          "inviteId": null,
          "winningId": null,
          "scoreChange": 50,
          "currentScore": 70,
          "operationSource": "福彩用户体验调研",
          "remark": "bcd",
          "createTime": "2025-05-14 00:53:08",
          "updateTime": "2025-05-14 00:53:08"
        },
        {
          "scoreId": "1922334254809772034",
          "openId": "bcd",
          "rule": {
            "createDept": 103,
            "createBy": 1,
            "createTime": "2025-05-14 00:52:56",
            "updateBy": 1,
            "updateTime": "2025-05-14 00:52:56",
            "ruleId": 2,
            "ruleTitle": "福彩用户体验调研",
            "rulePhrase": "花开中国梦",
            "ruleDesc": "用户首次参与活动额外奖励20积分，仅限一次",
            "ruleCode": 2,
            "ruleClass": "4元电脑票体验券",
            "ruleScore": 20,
            "ruleStatus": 0,
            "operationType": 0,
            "isVisible": 0
          },
          "scanId": null,
          "inviteId": null,
          "winningId": null,
          "scoreChange": 20,
          "currentScore": 20,
          "operationSource": "福彩用户体验调研",
          "remark": "邀请注册，首次参与赠送积分",
          "createTime": "2025-05-14 00:52:56",
          "updateTime": "2025-05-14 00:52:56"
        },
        {
          "scoreId": "1922333418717212674",
          "openId": "abc",
          "rule": {
            "createDept": 103,
            "createBy": 1,
            "createTime": "2025-05-14 00:49:37",
            "updateBy": 1,
            "updateTime": "2025-05-14 00:49:37",
            "ruleId": 2,
            "ruleTitle": "福彩用户体验调研",
            "rulePhrase": "花开中国梦",
            "ruleDesc": "用户首次参与活动额外奖励20积分，仅限一次",
            "ruleCode": 2,
            "ruleClass": "4元电脑票体验券",
            "ruleScore": 20,
            "ruleStatus": 0,
            "operationType": 0,
            "isVisible": 0
          },
          "scanId": null,
          "inviteId": null,
          "winningId": null,
          "scoreChange": 20,
          "currentScore": 20,
          "operationSource": "福彩用户体验调研",
          "remark": "自行注册，首次参与赠送积分",
          "createTime": "2025-05-14 00:49:37",
          "updateTime": "2025-05-14 00:49:37"
        },
      ]
    }
  },

  components: {
    InnerLoading,
  },
  watch:{
    // 监控参数变化更新游戏列表接口数据
    searchParams:function() {
      if(this.url_openid){
        this.getDataList();
      }
    },
  },
  computed:{
    // 监控参数变化更新游戏列表接口数据
    searchParams() {
      return {
        pageSize:this.size1,//每页数量
        pageNum:this.page1,//当前页码
        // openId:this.user_openid,//
        // orderByColumn:'createTime',
        // isAsc:'asc',
        // operationType:this.activeTab//积分类型
      };
    },
  },
  created(){

    // 从公众号进来，先判断是否登陆过
    // 如果登陆过，直接无感登陆
    // 如果没有登录过，自己填写手机号验证码登录
    // 获取openid
    this.url_openid = this.$route.query.openid;
    if(this.$route.query.openid){
      this.url_openid = this.$route.query.openid;
    }else{

    }
  },
  methods:{

    onLoad() {
      setTimeout(() => {
        if(this.page1<this.totalPages1){
          this.page1 = this.page1+1;
        }
      },1000);
    },
    getDataList(){
      this.loading1 = true;
      this.finished1 = false;
      this.searchParams.openId = this.url_openid;
      if(this.searchParams.openId) {
        return false;
        // this.$http.lottery_score_list(this.searchParams).then((res) => {
        //   if (res) {
        //     this.loading1 = false;
        //     if (res.code&&res.code === 200) {
        //       this.totals1 = res.total;
        //       this.totalPages1 = Math.ceil(res.total / this.size1);
        //       if (res.rows == null || res.rows.length === 0) {
        //         this.finished1 = true;
        //         this.listData = [];
        //         return false;
        //       } else {
        //         if (this.page1 > 1) {
        //           this.listData = this.listData.concat(res.rows);
        //         } else {
        //           this.listData = res.rows;
        //         }
        //         // 总条数和每页条数
        //         if (this.totals1 < this.size1) {
        //           this.finished1 = true;
        //           return;
        //         }
        //         // 当前页和总页数
        //         if (this.page1 === this.totalPages1) {
        //           this.finished1 = true;
        //           return false;
        //         }
        //       }
        //     } else {
        //       if(res.msg){
        //         this.$toast(res.msg);
        //       }
        //     }
        //   }
        // });
      }
    },

  },
}
</script>

<template>
  <div class="home">
    <inner-loading v-model="innerLoading"></inner-loading>
    <div class="fixed-box">
      <div class="my-tickets">
        <div class="ticket-stats">
          <div class="ticket-stat">
            <span class="images-stat"><img src="@/assets/images/1.png" alt=""></span>
            <span class="label">4元电脑票</span>
            <span class="number">10</span>
            <span class="all-number">总金额：40元</span>
          </div>
<!--          <div class="ticket-stat">-->
<!--            <span class="label">10元快乐8</span>-->
<!--            <span class="number">2</span>-->
<!--            <span class="all-number">总金额：20元</span>-->
<!--          </div>-->
        </div>
      </div>
    </div>

    <div class="contents">
      <div class="conte-item">
        <!-- 分类筛选 -->
        <div class="filter-section">
          <van-tabs v-model="activeTab" animated swipeable sticky>
            <van-tab title="全部记录" name="2"></van-tab>
            <van-tab title="4元电脑票" name="3"></van-tab>
          </van-tabs>
        </div>
        <div class="taner-box">
          <van-list v-model="loading1" :finished="finished1" :finished-text="finishedMsgTxt" :immediate-check="false" @load="onLoad">
            <div class="points-item" v-for="(item,index) in listData" :key="index">
              <div class="point-de">
                <img src="@/assets/images/1.png" alt="">
              </div>
              <div class="point-he">
                <div class="points-item-header">
                  <div class="points-item-title">{{item.rule.ruleClass}}  <span>10元</span></div>
                  <span class="points-item-amount increase">
                  已核销
                </span>
                </div>
                <div class="points-item-details">
                  {{item.rule.createTime}}
                </div>
                <div class="points-item-details">
                  券码：HB9238932849324932
                </div>
              </div>
            </div>
          </van-list>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
.home{
  height: 100%;
  width: 100%;
  .fixed-box{
    position: fixed;
    left: 0;
    top: 0;
    z-index: 2;
    height: 420px;
    width: 100%;
    padding-top: 90px;
    box-sizing: border-box;
    background: #f5f5f5;
    .tabs{
      z-index: 2;
    }
    .my-tickets {
      padding: 30px 10px 0;
      text-align: center;
    }

    .my-tickets h3 {
      margin-bottom: 15px;
    }

    .ticket-stats {
      display: flex;
      justify-content: space-around;
    }

    .ticket-stat {
      flex: 1;
      text-align: center;
      border-radius: 10px;
      background: #fff;
      padding:30px 20px;
      margin: 0 10px 20px;
    }
    .ticket-stat .images-stat{
      display: block;
      img{
        width: 80px;
      }
    }
    .ticket-stat .number {
      font-weight: bold;
      display: block;
      color: #e62d2d;
      font-size: 38px;
    }
    .ticket-stat .all-number {
      display: block;
      color: #666;
      font-size: 26px;
    }
    .ticket-stat .label {
      opacity: 0.9;
    }

    .ticket-buttons {
      display: flex;
      gap: 10px;
    }

    .ticket-btn {
      flex: 1;
      background: rgba(255,255,255,0.2);
      border: 1px solid rgba(255,255,255,0.3);
      color: white;
      padding: 12px;
      border-radius: 50px;
      cursor: pointer;
      transition: all 0.3s ease;
    }

    .ticket-btn:hover {
      background: rgba(255,255,255,0.3);
    }
  }

  .contents{
    padding-top: 420px;
    .conte-item{
      padding:10px 20px 20px 20px;
      .filter-section {
        display: flex;
        margin-bottom:20px;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        scrollbar-width: none; /* Firefox */
        background: #fff;
        border-radius:10px;
        .van-tabs{
          width: 100%;
        }
      }

      .filter-section::-webkit-scrollbar {
        display: none; /* Chrome, Safari, Edge */
      }
      .active1{
        background: #FF6B6B !important;
        color: #fff !important;
      }

      .filter-btn {
        flex: 1;
        //padding: 10px;
        //text-align: center;
        //border: none;
        //background: transparent;
        //color: #666;
        //cursor: pointer;
        //border-radius: 8px;
        //transition: all 0.3s ease;
        //-----
        //padding: 12px 56px;
        background: #fff;
        //border: 1px solid #e0e0e0;
        //border-radius: 40px;
        //margin-right: 10px;
        font-size: 26px;
        color: #666;
        white-space: nowrap;
        cursor: pointer;
      }
    }
  }

}

.taner-box{
  //position: fixed;
  //left: 0;
  //top: 0;
  //z-index: 1;
  //height: 100vh;
  width: 100%;
  //overflow-y: auto;
  //padding: 480px 20px 0 20px;
  box-sizing: border-box;
}
.points-list {
  flex: 1;
  overflow-y: auto;
  padding: 0 30px;
  max-height: 62vh;
  width: 100%;
  background-color: #f7f7f7;
}

.points-item {
  display: flex;
  flex-direction: row;
  background: white;
  border-radius: 12px;
  padding: 30px;
  margin-bottom: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  width: 100%;

  .point-de {
    display: flex;
    width: 20%;
    img{
      width: 120px;
      height: 120px;
    }
  }

  .point-he {
    display: flex;
    flex-direction: column;
    width: 80%;

  }
}
.points-item-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.points-item-title {
  font-weight: 500;
  color: #333;
  font-size: 28px;
  span{
    display: inline-block;
    padding: 2px 14px;
    border-radius: 50px;
    color: #fff;
    background: #e62d2d;
    font-size: 24px;
  }
}

.points-item-amount {
  font-weight: bold;
  font-size: 26px;
  padding: 4px 14px;
  border-radius:40px;
}

.points-item-amount.increase {
  background: #e8f5e8;
  color: #28a745;
}

.points-item-amount.decrease {
  background: #d1ecf1;
  color: #0c5460;
}
.points-item-amount.un-crease{
  background: #f8d7da;
  color: #dc3545;
}
.points-item-details {
  display: flex;
  color: #999;
  font-size: 26px;
  margin-top: 10px;
  .points-item-time{
    margin-top: 10px;
  }
  span{
    display: inline-block;
  }
}


.action-btn {
  padding: 10px 20px;
  border-radius: 10px;
  font-size: 28px;
  border: none;
  cursor: pointer;
}

.receive-btn {
  background-color: #4CAF50;
  color: white;
}
.points-item-tag {
  display: inline-block;
  //padding: 2px 6px;
  //background-color: #f0f0f0;
  //border-radius: 4px;
  font-size: 26px;
  color: #666;
  margin-right: 5px;
}

.points-item-status {
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 26px;
}

.status-success {
  background-color: #e8f5e9;
  color: #4CAF50;
}

.load-more {
  text-align: center;
  padding: 15px;
  color: #666;
  cursor: pointer;
}

</style>